/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagSection } from '../../models/tag-section';

export interface MagnetGetTagList$Params {

/**
 * GUID of the magnet
 */
  magnetId: string;
}

export function magnetGetTagList(http: HttpClient, rootUrl: string, params: MagnetGetTagList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TagSection>>> {
  const rb = new RequestBuilder(rootUrl, magnetGetTagList.PATH, 'get');
  if (params) {
    rb.path('magnetId', params.magnetId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TagSection>>;
    })
  );
}

magnetGetTagList.PATH = '/magnet/{magnetId}/tag/list';
